import { WheelField } from "../../../../util/enums";
import { wheelFields } from "../WheelOfFortune.constants";


const calculateAngleFromField = (fieldsContainingPrize: WheelField[]): number => {
    const randomIndex = Math.floor(Math.random() * fieldsContainingPrize.length);
    const chosenField = fieldsContainingPrize[randomIndex];

    const chosenFieldOrder = wheelFields.findIndex(field => field.id === chosenField.id) + 1;

    return (360 / wheelFields.length) * chosenFieldOrder;
}

export default calculateAngleFromField;